import { useUiStore } from '../store/ui.js';

// Moon/sun toggle (mockup #themeToggle). Both icons are always
// rendered; tokens.css shows the correct one based on
// :root[data-theme]. Click flips the Zustand theme, which applies the
// data-theme attribute and persists to localStorage['pointage:theme']
// (see store/ui.ts). Two placements: the default 'fixed' variant
// floats top-right on the chrome-less login page; inside the app
// shell the Header mounts the 'inline' variant in the topbar flow,
// after the user menu — the fixed one overlapped it.
export function ThemeToggle({ variant = 'fixed' }: { variant?: 'fixed' | 'inline' }) {
  const theme = useUiStore((s) => s.theme);
  const toggleTheme = useUiStore((s) => s.toggleTheme);

  return (
    <button
      type="button"
      className={variant === 'inline' ? 'theme-toggle theme-toggle--inline' : 'theme-toggle'}
      onClick={toggleTheme}
      aria-label="Basculer le thème"
      title={theme === 'dark' ? 'Passer en thème clair' : 'Passer en thème sombre'}
      data-testid="theme-toggle"
    >
      <svg
        className="icon-moon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
      <svg
        className="icon-sun"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
      </svg>
    </button>
  );
}
